import A from "long";
import * as c from "protobufjs/minimal.js";
const u = "default" in c ? c.default : c;
var s;
(function(n) {
  n[n.UNKNOWN_DO_NOT_USE = 0] = "UNKNOWN_DO_NOT_USE", n[n.MONDAY = 1] = "MONDAY", n[n.TUESDAY = 2] = "TUESDAY", n[n.WEDNESDAY = 3] = "WEDNESDAY", n[n.THURSDAY = 4] = "THURSDAY", n[n.FRIDAY = 5] = "FRIDAY", n[n.SATURDAY = 6] = "SATURDAY", n[n.SUNDAY = 7] = "SUNDAY";
})(s || (s = {}));
var f;
(function(n) {
  n[n.MONTH_OF_YEAR_UNSPECIFIED = 0] = "MONTH_OF_YEAR_UNSPECIFIED", n[n.JANUARY = 1] = "JANUARY", n[n.FEBRUARY = 2] = "FEBRUARY", n[n.MARCH = 3] = "MARCH", n[n.APRIL = 4] = "APRIL", n[n.MAY = 5] = "MAY", n[n.JUNE = 6] = "JUNE", n[n.JULY = 7] = "JULY", n[n.AUGUST = 8] = "AUGUST", n[n.SEPTEMBER = 9] = "SEPTEMBER", n[n.OCTOBER = 10] = "OCTOBER", n[n.NOVEMBER = 11] = "NOVEMBER", n[n.DECEMBER = 12] = "DECEMBER";
})(f || (f = {}));
function l() {
  return {
    $type: "squareup.common.time.DateTime",
    instantUsec: void 0,
    timezoneOffsetMin: void 0,
    posixTz: void 0,
    tzName: [],
    ordinal: void 0
  };
}
const o = {
  $type: "squareup.common.time.DateTime",
  encode(n, e = u.Writer.create()) {
    const i = N();
    try {
      n.instantUsec !== void 0 && e.uint32(8).int64(n.instantUsec), n.timezoneOffsetMin !== void 0 && e.uint32(16).sint32(n.timezoneOffsetMin), n.posixTz !== void 0 && e.uint32(26).string(n.posixTz);
      for (const r of n.tzName)
        e.uint32(34).string(r);
      return n.ordinal !== void 0 && e.uint32(40).int64(n.ordinal), e;
    } finally {
      i();
    }
  },
  decode(n, e) {
    const i = N();
    try {
      const r = n instanceof u.Reader ? n : u.Reader.create(n);
      let d = e === void 0 ? r.len : r.pos + e;
      const t = l();
      for (; r.pos < d; ) {
        const a = r.uint32();
        switch (a >>> 3) {
          case 1:
            if (a !== 8)
              break;
            t.instantUsec = T(r.int64());
            continue;
          case 2:
            if (a !== 16)
              break;
            t.timezoneOffsetMin = r.sint32();
            continue;
          case 3:
            if (a !== 26)
              break;
            t.posixTz = r.string();
            continue;
          case 4:
            if (a !== 34)
              break;
            t.tzName.push(r.string());
            continue;
          case 5:
            if (a !== 40)
              break;
            t.ordinal = T(r.int64());
            continue;
        }
        if ((a & 7) === 4 || a === 0)
          break;
        r.skipType(a & 7);
      }
      return t;
    } finally {
      i();
    }
  },
  create(n) {
    return o.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = l();
    return e.instantUsec = n.instantUsec ?? void 0, e.timezoneOffsetMin = n.timezoneOffsetMin ?? void 0, e.posixTz = n.posixTz ?? void 0, e.tzName = ((i = n.tzName) == null ? void 0 : i.map((r) => r)) || [], e.ordinal = n.ordinal ?? void 0, e;
  }
};
function E() {
  return { $type: "squareup.common.time.DateTimeInterval", inclusiveStart: void 0, exclusiveEnd: void 0 };
}
const R = {
  $type: "squareup.common.time.DateTimeInterval",
  encode(n, e = u.Writer.create()) {
    return n.inclusiveStart !== void 0 && o.encode(n.inclusiveStart, e.uint32(10).fork()).ldelim(), n.exclusiveEnd !== void 0 && o.encode(n.exclusiveEnd, e.uint32(18).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const d = E();
    for (; i.pos < r; ) {
      const t = i.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 10)
            break;
          d.inclusiveStart = o.decode(i, i.uint32());
          continue;
        case 2:
          if (t !== 18)
            break;
          d.exclusiveEnd = o.decode(i, i.uint32());
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      i.skipType(t & 7);
    }
    return d;
  },
  create(n) {
    return R.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = E();
    return e.inclusiveStart = n.inclusiveStart !== void 0 && n.inclusiveStart !== null ? o.fromPartial(n.inclusiveStart) : void 0, e.exclusiveEnd = n.exclusiveEnd !== void 0 && n.exclusiveEnd !== null ? o.fromPartial(n.exclusiveEnd) : void 0, e;
  }
};
function m() {
  return { $type: "squareup.common.time.YearMonthDay", year: void 0, monthOfYear: void 0, dayOfMonth: void 0 };
}
const U = {
  $type: "squareup.common.time.YearMonthDay",
  encode(n, e = u.Writer.create()) {
    return n.year !== void 0 && e.uint32(8).int32(n.year), n.monthOfYear !== void 0 && e.uint32(16).int32(n.monthOfYear), n.dayOfMonth !== void 0 && e.uint32(24).int32(n.dayOfMonth), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const d = m();
    for (; i.pos < r; ) {
      const t = i.uint32();
      switch (t >>> 3) {
        case 1:
          if (t !== 8)
            break;
          d.year = i.int32();
          continue;
        case 2:
          if (t !== 16)
            break;
          d.monthOfYear = i.int32();
          continue;
        case 3:
          if (t !== 24)
            break;
          d.dayOfMonth = i.int32();
          continue;
      }
      if ((t & 7) === 4 || t === 0)
        break;
      i.skipType(t & 7);
    }
    return d;
  },
  create(n) {
    return U.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = m();
    return e.year = n.year ?? void 0, e.monthOfYear = n.monthOfYear ?? void 0, e.dayOfMonth = n.dayOfMonth ?? void 0, e;
  }
};
function T(n) {
  if (n.gt(globalThis.Number.MAX_SAFE_INTEGER))
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n.lt(globalThis.Number.MIN_SAFE_INTEGER))
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n.toNumber();
}
const N = () => {
  const n = u.util.Long;
  return u.util.Long = A, u.configure(), () => {
    u.util.Long = n, u.configure();
  };
};
export {
  o as DateTime,
  R as DateTimeInterval,
  s as DayOfWeek,
  f as MonthOfYear,
  U as YearMonthDay
};
